import type { TagSetScope } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import DeletableChip from "~/components/Chips/DeletableChip";
import { MultiSelect } from "~/components/MultiSelect/MultiSelect";
import type { FormFieldProps } from "~/components/form";
import type { ComponentProps } from "~/utils/types";
interface TagSetScopeMultiSelectProps extends FormFieldProps<string[]> {
    items: {
        Id: string;
        Name: string;
    }[];
    autoFocus?: boolean;
    label?: string | JSX.Element;
    error?: string;
    accessibleName?: string;
    renderChip?: (item: {
        Id: string;
        Name: string;
    }, onRequestDelete: () => void) => JSX.Element;
}
const TagSetScopeTypedMultiSelect = MultiSelect<{
    Id: string;
    Name: string;
}>();
type RenderChip = ComponentProps<typeof TagSetScopeTypedMultiSelect>["renderChip"];
export const TagSetScopeMultiSelect: React.FC<TagSetScopeMultiSelectProps> = (props) => {
    const defaultChipRenderer: RenderChip = (item, onRequestDelete: () => void) => {
        return (<DeletableChip description={`${item.Id}: ${item.Name}`} key={item.Id} onRequestDelete={onRequestDelete} deleteButtonAccessibleName={`Remove ${item.Name}`}>
                {item.Name}
            </DeletableChip>);
    };
    const chipRenderer = props.renderChip || defaultChipRenderer;
    return <TagSetScopeTypedMultiSelect fieldName="tag set scopes" renderChip={chipRenderer} accessibleName={props.accessibleName} {...props} items={props.items}/>;
};
TagSetScopeMultiSelect.displayName = "TagSetScopeMultiSelect"
export const SupportedTagSetScopes: TagSetScope[] = ["Tenant", "Environment", "Project"];
